// extracted by mini-css-extract-plugin
export var content = "_7n-3";
export var list = "_7n-4";
export var settingsContent = "_7n-7";
export var settingsPanel = "_7n-8";
export var state = "_7n-6";
export var triggerBadge = "_7n-2";
export var triggerButton = "_7n-1";
export var triggerShell = "_7n-0";
export var unreadDot = "_7n-5";